import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UiBeAMemberButtonComponent } from './ui-be-a-member-button/ui-be-a-member-button.component';
import { UiThemeModule } from '@fitscovery/partner-web/ui/theme';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, RouterModule, UiThemeModule, TranslateModule],
  declarations: [UiBeAMemberButtonComponent],
  exports: [UiBeAMemberButtonComponent]
})
export class PartnerWebSharedUiBeAMemberButtonModule { }
